/* eslint-disable no-loop-func */
/* eslint-disable no-undef */
/* eslint-disable no-unused-vars */
import React, { useState, useEffect } from "react";
import { makeStyles } from "@mui/styles";
//*MUI
import { Box, Modal } from "@mui/material";
//*files
import cssClasses from "./AlotExistingUnit.module.css";
import Close from "../../Components/Icons/Close";
//subComponent
import CustomInput from "../../Subcomponents/CustomInput";
import Button from "../../Subcomponents/Button";

import Radio from "@mui/material/Radio";
import RadioGroup from "@mui/material/RadioGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import FormControl from "@mui/material/FormControl";

//Icons
import ArrowCircleRightOutlinedIcon from "@mui/icons-material/ArrowCircleRightOutlined";
import ImageOutlinedIcon from "@mui/icons-material/ImageOutlined";

import {
  errorTost,
  infoTost,
  offlineToast,
  successTost,
} from "../../Services/Toast";
import { dismissLoader, presentLoader } from "../../Services/loader";

import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import {
  getAllotedDataInAlotExistingUnit,
  getAllotedDataInChangeUnit,
} from "../../Services/AlotUnit";
import { forEach, sortBy, sortedUniqBy, uniqBy } from "lodash";
import {
  getInventoryExceptSelectedOne,
  updateAllotmentTransactionsForTrnsUpdate,
  updateInventoryStatus,
} from "../../Services/ChangeUnit";
import DropDown from "../../Subcomponents/DropDown";
import Dot from "../../Components/Icons/Dot";
import LeadStatusChip from "../../Subcomponents/LeadStatusChip";
import {
  getAllAllotmentTransactions,
  getEventLeadTokenAmount,
  insertInventoryLogs,
  insertTransactionLogs,
  updateAllotmentPayment,
  updateEventLeadTokenAmount,
} from "../../Services/AllAllotments";
import { addLeadLogs, updateLeadAllStatus } from "../../Services/Lead";
import { getAllInventoryStatusFromTable } from "../../Services/SustenanceService";
import ConfirmationAlert from "../../Subcomponents/ConfirmationAlert";
import { sendMailTo, sendMessage } from "../../Services/SmsService";
import { bucketingForChangeUnit } from "../../Services/PaymentApi";
import { getAllotmentCancelledTransection } from "../../Services/Payments";
const useStyles = makeStyles((theme) => ({
  wrapperIcons: {
    display: "flex",
    flexDirection: "row",
    alignItems: "flex-start",
    justifyContent: "space-around",
    marginBottom: "2rem",
    position: "relative",
  },
  closeIcon: {
    cursor: "pointer",
    position: "absolute",
    right: "1.7rem",
    top: "1.7rem",
  },
  title: {
    fontFamily: "Inter-Medium",
    fontStyle: "normal",
    fontWeight: "500",
    fontSize: "1.8rem",
    lineHeight: "2.8rem",
    color: "#101828",
    marginBottom: "0.8rem",
  },
  subTitle: {
    fontFamily: "Inter-Medium",
    fontStyle: "normal",
    fontWeight: "500",
    fontSize: "1.4rem",
    lineHeight: "2rem",
    color: "#667085",
    marginBottom: "3.2rem",
  },
  labelCard: {
    fontFamily: "Inter-Medium",
    fontStyle: "normal",
    fontWeight: "500",
    fontSize: "1.4rem",
    lineHeight: "2rem",
    color: "#667085",
    marginBottom: "3.2rem",
  },
  labelValue: {
    fontFamily: "Inter-Medium",
    fontStyle: "normal",
    fontWeight: "500",
    fontSize: "1.4rem",
    lineHeight: "2rem",
    // color: "#667085",
    marginBottom: "3.2rem",
    color: " #000000",
    textTransform: "capitalize",
  },
  projectAddress: {
    fontFamily: "Inter-Medium",
    fontStyle: "normal",
    fontWeight: "500",
    fontSize: "1.4rem",
    lineHeight: "2rem",
    color: "#667085",
    marginBottom: "3.2rem",
    // marginLeft: "1rem",
    textTransform: "capitalize",
  },
  wrapperButtons: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "space-between",
    columnGap: "1.2rem",
  },
  backArrow: {
    verticalAlign: "middle",
  },
}));

export default function AlotExistingUnit({
  open,
  handleClose,
  returnRes,
  data,
  oldAllotmentData,
  selectedAllotment = null,
  transactionsFound,
}) {
  const classes = useStyles();
  const navigate = useNavigate();
  const [numberNext, setNumberNext] = useState(0);
  let loggedInUser = {};
  loggedInUser = useSelector((state) => state.Auth.user);
  console.log(loggedInUser);
  const [hideChoices, setHideChoices] = useState(false);
  const [projectNameList, setProjectNameList] = useState([]);
  const [wingNameList, setWingNameList] = useState([]);
  const [floorList, setFloorList] = useState([]);
  const [unitNoList, setUnitNoList] = useState([]);
  const [allotedData, setAllotedData] = useState([]);
  const [openAlertBoxForAdjustAmount, setOpenAlertBoxForAdjustAmount] =
    useState(false);
  const [availableData, setAvailableData] = useState({
    projectName: "",
    projectId: "",
    unitNo: "",
    unitId: "",
    floorNo: "",
    wingName: "",
    wingId: "",
    allotedUnitData: null,
  });
  const [paymentPendingInventoryStatus, setPaymentPendingInventoryStatus] =
    useState(null);
  const [kycDoneInventoryStatus, seKycDoneInventoryStatus] = useState(null);
  const [kycPendingInventoryStatus, setKycPendingInventoryStatus] =
    useState(null);
  const [allotmentTransactionFound, setAllotmentTransactionFound] =
    useState(null);
  const [showCancelledInFarvisionMsg, setShowCancelledInFarvisionMsg] =
    useState(false);
  useEffect(() => {
    if (numberNext === 1) {
      getAllotedUnit();
      inventoryStatus();
    }

    console.log('oldAllotmentData', oldAllotmentData)
  }, [numberNext]);
  useEffect(() => {
    if (numberNext === 0) {
      presentLoader();
      if (oldAllotmentData.status !== "Cancellation Not Done") {
        getAllotmentCancelledTransection(oldAllotmentData.allotmentpaymentid)
          .then((resp) => {
            resp?.length > 0 &&
              resp[0]?.cancelledInFarvision &&
              setShowCancelledInFarvisionMsg(true);
            setAllotmentTransactionFound(true)
            dismissLoader();
          })
          .catch((err) => {
            dismissLoader();
            console.log(err);
          });
      } else {
        if (transactionsFound.length > 0) {
          setAllotmentTransactionFound(true);
          dismissLoader();
        } else {
          setAllotmentTransactionFound(false);
          dismissLoader();
        }
      }
    }
  }, [transactionsFound]);

  function getAllotedUnit() {
    getAllotedDataInAlotExistingUnit(data.leadId)
      .then((allotedData) => {
        console.log({ allotedData });
        let allotedProject = [];
        if (allotedData?.data.length > 0) {
          allotedData?.data.forEach((el) => {
            let object = {
              label:
                el?.unitId?.projectId?.projectName ??
                el?.inventoryMergedId?.projectId?.projectName,
              value:
                el?.unitId?.projectId?.projectId ??
                el?.inventoryMergedId?.projectId?.projectId,
            };
            allotedProject.push(object);
          });
          console.log({ allotedData });
          setProjectNameList(uniqBy([...allotedProject], "label"));
          allotedData.data = allotedData.data.map((el) => ({
            ...el,
            unitData: el?.unitId ?? el?.inventoryMergedId?.unit1Id,
            // unitId: el.unitId?.unitId ?? el?.inventoryMergedId?.unit1Id?.unitId,
          }));
          setAllotedData([...allotedData.data]);
          // ??we got project now filtering based on selected projects wings (not all wings)
          // let filterWings= allotedData.data.filter((el)=>el.unitData.wingId);
          findWing(allotedData.data, allotedProject[0].value);
          // setSelectedLeadId(allotedData.data[allotmentDataIndex].leadId);
        } else {
          setProjectNameList(["No Projects Available"]);
          setWingNameList(["No Wings Available"]);
          setUnitNoList(["No Units Available"]);
          setFloorList(["No Floors Available"]);
          // setErrorMessage('No Units Available to Change');
        }
      })
      .catch((err) => {
        console.log(err);
      });
  }
  function findWing(allotedData, projectId) {
    let filterWings = allotedData.filter((el) => {
      if (el?.unitData?.projectId?.projectId === projectId) {
        return true;
      }
      return false;
    });
    console.log("filterWings: ", filterWings[0]?.unitData?.wingId);
    //   ??can do selection
    setWingNameList(uniqBy([...filterWings], "wingId"));
    //   setWingNameList([filterWings[0].unitData.wingId]);
    //   ??else can have multiple wings
    findFloor(allotedData, projectId, filterWings[0]?.unitData?.wingId?.wingId);
  }
  function findFloor(allotedData, projectId, wingId) {
    let filterFloor = allotedData.filter((el) => {
      if (
        el?.unitData?.projectId?.projectId === projectId &&
        el?.unitData?.wingId?.wingId === wingId
      ) {
        return true;
      }
      return false;
    });
    console.log("filterNo: ", filterFloor);
    filterFloor = filterFloor.map((el) => ({
      ...el,
      sortedFloor: el?.unitData?.floorNo,
    }));
    console.log("sortedFloor", filterFloor);
    setFloorList(
      sortedUniqBy(
        uniqBy([...filterFloor], "sortedFloor"),
        "sortedFloor",
        "desc"
      )
    );
    findUnit(allotedData, projectId, wingId, filterFloor[0]?.unitData?.floorNo);
  }
  function findUnit(allotedData, projectId, wingId, floorNo) {
    let filterUnits = allotedData.filter((el) => {
      if (
        el?.unitData?.projectId?.projectId === projectId &&
        el?.unitData?.wingId?.wingId === wingId &&
        el?.unitData?.floorNo === floorNo
      ) {
        return true;
      }
      return false;
    });
    console.log("filterUnits: ", filterUnits);
    setUnitNoList([...filterUnits]);
    setAvailableData((pre) => {
      pre.projectId = projectId;
      pre.wingId = wingId;
      pre.projectName = filterUnits[0]?.unitData?.projectId?.projectName;
      pre.wingName = filterUnits[0]?.unitData?.wingId?.wingName;
      pre.floorNo = floorNo;
      pre.unitNo = filterUnits[0]?.unitData?.unitNo;
      pre.unitId = filterUnits[0]?.unitData?.unitId;
      pre.allotedUnitData = filterUnits[0];
      return { ...pre };
    });
  }
  function numberWithCommas(x) {
    return x?.toString().replace(/\B(?=(?:(\d\d)+(\d)(?!\d))+(?!\d))/g, ",");
  }
  function closeModal() {
    handleClose();
  }
  async function sendMailAndSms(email, subject) {
    // let message = `<h4>Hi ${oldAllotmentData?.leadname},</h4></br>
    //   <p>Adjust Allotment Done!</br>
    //   Cancelled Unit:${oldAllotmentData.projectname},${oldAllotmentData.wingname},${oldAllotmentData.unitno}</br>
    //   Balance amount: ${oldAllotmentData.paidamount} has been adjusted in ${availableData?.projectName}|${availableData?.wingName} |${availableData?.unitNo}</br>
    //   Done by ${loggedInUser?.name}(${loggedInUser?.roleId?.title})</b></p></br>
    //  `;
    let message = `<h4>Hi ${oldAllotmentData?.leadname},</h4></br>
      <p>Adjust Allotment Done!</br>
      Cancelled Unit:${oldAllotmentData.projectname},${oldAllotmentData.displaywingname ? oldAllotmentData.displaywingname : oldAllotmentData.wingname},${oldAllotmentData.unitno}</br>
      Balance amount: ${oldAllotmentData.paidamount} has been adjusted in ${availableData?.projectName}|${availableData?.displayName ? availableData?.displayName : availableData?.wingName} |${availableData?.unitNo}</br>
      Done by ${loggedInUser?.name}(${loggedInUser?.roleId?.title})</b></p></br>
     `;
    let emailbody = {
      to: [email],
      subject: subject,
      message: message,
    };
    let messageBody = {
      number: "+" + data.leadcontactnumber,
      message: `Cancelled Unit:${oldAllotmentData.projectname},${oldAllotmentData.wingname},${oldAllotmentData.unitno}, balance amount: ${oldAllotmentData.paidamount} has been adjusted in ${availableData?.projectName}|${availableData?.wingName} |${availableData?.unitNo} done by ${loggedInUser?.name}(${loggedInUser?.roleId?.title})`,
      is_international_number:
        data.leadcontactnumber.toString().substring(0, 2) !== "91"
          ? true
          : false,
    };
    // const sms = await sendMessage(messageBody)
    //   .then((resp) => {
    //     if (resp.data.success) {
    //       return true;
    //     } else {
    //       if (resp?.data?.error) {
    //         return false;
    //       }
    //     }
    //   })
    //   .catch((err) => {
    //     return false;
    //   });
    const emailRes = await sendMailTo(emailbody)
      .then((resp) => {
        console.log(resp);
        if (resp.data.status === "err") {
          return false;
        } else {
          return true;
        }
      })
      .catch((err) => {
        console.log(err);
        return false;
      });
    // sms
    return { emailRes };
  }
  function submit() {
    console.log({ oldAllotmentData }, availableData?.allotedUnitData);
    getAllAllotmentTransactions(oldAllotmentData?.allotmentpaymentid).then(
      async (allotmentTransactionResponse) => {
        console.log({ allotmentTransactionResponse });
        let allotmentTransactions = allotmentTransactionResponse.data.filter(
          (el) => el.status === "complete"
        );
        // ??Had previous transactions
        // if (allotmentTransactions.length > 0) {
          presentLoader();
          // ??Avaiable Unit BookingAmountOcr
          let alreadyFilledOcr =
            availableData?.allotedUnitData?.paidAmt?.ocr ?? 0;
          let alreadyFilledGst =
            availableData?.allotedUnitData?.paidAmt?.gst ?? 0;
          let alreadyFilledSdr =
            availableData?.allotedUnitData?.paidAmt?.sdr ?? 0;
          // for (const eachAllotmentTransaction of allotmentTransactions) {
          //   let assumedBookingAmountOcr = 0;
          //   let assumedBookingAmountSdr = 0;
          //   let assumedBookingAmountGst = 0;
          //   let assumedUnitCostOcr = 0;
          //   let assumedUnitCostSdr = 0;
          //   let assumedUnitCostGst = 0;
          //   let transactionTotalAmount = eachAllotmentTransaction.amount;
          //   // !!currently not included cancellation charges
          //   // ??as i don't know where to cut it from as these are transactions
          //   if (
          //     transactionTotalAmount > 0 &&availableData?.allotedUnitData?.bookingAmt?.ocr -alreadyFilledOcr >0
          //   ) {
          //     if (transactionTotalAmount >availableData?.allotedUnitData?.bookingAmt?.ocr -alreadyFilledOcr) {
          //       assumedBookingAmountOcr =availableData?.allotedUnitData?.bookingAmt?.ocr -alreadyFilledOcr;
          //     } else {
          //       assumedBookingAmountOcr = transactionTotalAmount;
          //     }
          //     transactionTotalAmount =transactionTotalAmount -(availableData?.allotedUnitData?.bookingAmt?.ocr -alreadyFilledOcr);
          //   }
          //   if (transactionTotalAmount > 0 &&availableData?.allotedUnitData?.bookingAmt?.gst -alreadyFilledGst > 0) {
          //     if (
          //       transactionTotalAmount >availableData?.allotedUnitData?.bookingAmt?.gst -alreadyFilledGst
          //     ) {
          //       assumedBookingAmountGst =availableData?.allotedUnitData?.bookingAmt?.gst -alreadyFilledGst;
          //     } else {
          //       assumedBookingAmountGst = transactionTotalAmount;
          //     }
          //     transactionTotalAmount = transactionTotalAmount -(availableData?.allotedUnitData?.bookingAmt?.gst -alreadyFilledGst);
          //   }
          //   if (transactionTotalAmount > 0 &&availableData?.allotedUnitData?.bookingAmt?.sdr -alreadyFilledSdr >0) {
          //     if (transactionTotalAmount >availableData?.allotedUnitData?.bookingAmt?.sdr -alreadyFilledSdr) {
          //       assumedBookingAmountSdr =availableData?.allotedUnitData?.bookingAmt?.sdr -alreadyFilledSdr;
          //     } else {
          //       assumedBookingAmountSdr = transactionTotalAmount;
          //     }
          //     transactionTotalAmount = transactionTotalAmount -(availableData?.allotedUnitData?.bookingAmt?.sdr -alreadyFilledSdr);
          //   }
          //   // ??Bucket is overFlow no adding it to unitCost Bucket

          //   if (transactionTotalAmount > 0 &&availableData?.allotedUnitData?.unitCost.sdr -(alreadyFilledSdr + assumedBookingAmountSdr) > 0) {
          //     if (transactionTotalAmount >availableData?.allotedUnitData?.unitCost.sdr - alreadyFilledSdr) {
          //       assumedUnitCostSdr =availableData?.allotedUnitData?.unitCost.sdr -alreadyFilledSdr;
          //     } else {
          //       assumedUnitCostSdr =assumedUnitCostSdr + transactionTotalAmount;
          //     }
          //     transactionTotalAmount =transactionTotalAmount -(availableData?.allotedUnitData?.unitCost.sdr -alreadyFilledSdr);
          //   }
          //   if (transactionTotalAmount > 0 &&availableData?.allotedUnitData?.unitCost.bsp -(alreadyFilledOcr + assumedBookingAmountOcr) >0
          //   ) {
          //     if (transactionTotalAmount >availableData?.allotedUnitData?.unitCost.bsp - alreadyFilledOcr) {
          //       assumedUnitCostOcr =availableData?.allotedUnitData?.unitCost.bsp -alreadyFilledOcr;
          //     } else {
          //       assumedUnitCostOcr = assumedUnitCostOcr + transactionTotalAmount;
          //     }
          //     transactionTotalAmount =transactionTotalAmount -(availableData?.allotedUnitData?.unitCost.bsp -alreadyFilledOcr);
          //   }
          //   if (
          //     transactionTotalAmount > 0 &&
          //     availableData?.allotedUnitData?.unitCost.gst -(alreadyFilledGst + assumedBookingAmountGst) >0
          //   ) {
          //     if (
          //       transactionTotalAmount >availableData?.allotedUnitData?.unitCost.gst - alreadyFilledGst
          //     ) {
          //       assumedUnitCostGst =availableData?.allotedUnitData?.unitCost.gst -alreadyFilledGst;
          //     } else {
          //       assumedUnitCostGst =assumedUnitCostGst + transactionTotalAmount;
          //     }
          //     transactionTotalAmount =transactionTotalAmount -(availableData?.allotedUnitData?.unitCost.gst -alreadyFilledGst);
          //   }
          //   alreadyFilledOcr =alreadyFilledOcr + assumedBookingAmountOcr + assumedUnitCostOcr;
          //   alreadyFilledGst =alreadyFilledGst + assumedBookingAmountGst + assumedUnitCostGst;
          //   alreadyFilledSdr =alreadyFilledSdr + assumedBookingAmountSdr + assumedUnitCostSdr;
          //   let allomentTransactionObj = {
          //     allotmentPaymentId:
          //       availableData?.allotedUnitData?.allotmentPaymentId,
          //     // ??new untiId
          //     unitId: availableData?.unitId,
          //     ocr: assumedBookingAmountOcr + assumedUnitCostOcr,
          //     gst: assumedBookingAmountGst + assumedUnitCostGst,
          //     sdr: assumedBookingAmountSdr + assumedUnitCostSdr,
          //   };
          //   await updateAllotmentTransactionsForTrnsUpdate(
          //     oldAllotmentData?.allotmentpaymentid,
          //     allomentTransactionObj
          //   )
          //     .then((resp) => {
          //       let logObj = {
          //         oldAllotmentId: oldAllotmentData?.allotmentpaymentid,
          //         newAllotmentId:
          //           availableData?.allotedUnitData?.allotmentPaymentId,
          //         userId: loggedInUser?.userId,
          //       };
          //       insertTransactionLogs(logObj)
          //         .then((resplog) => {
          //           console.log({ resplog });
          //         })
          //         .catch((err) => {
          //           console.log("err while inserting logs");
          //         });
          //     })
          //     .catch((errorWhileUpdatingTranactions) => {
          //       console.log({ errorWhileUpdatingTranactions });
          //     });
          // }
          let allomentTransactionObj = {
            unitId: availableData?.unitId,
            allotmentPaymentId:
              availableData?.allotedUnitData?.allotmentPaymentId,

          };
          // ??end of for loop
          await updateAllotmentTransactionsForTrnsUpdate(
            oldAllotmentData?.allotmentpaymentid,
            allomentTransactionObj
          )
            .then((resp) => {
              let logObj = {
                oldAllotmentId: oldAllotmentData?.allotmentpaymentid,
                newAllotmentId:
                  availableData?.allotedUnitData?.allotmentPaymentId,
                userId: loggedInUser?.userId,
              };
              insertTransactionLogs(logObj)
                .then((resplog) => {
                  console.log({ resplog });
                })
                .catch((err) => {
                  console.log("err while inserting logs");
                });
            })
            .catch((errorWhileUpdatingTranactions) => {
              console.log({ errorWhileUpdatingTranactions });
            });
        let paidData = (oldAllotmentData?.paidamount + availableData?.allotedUnitData?.paidAmount ?? 0) - (oldAllotmentData?.updatedunitprice !== null ? oldAllotmentData?.updatedunitprice?.cancellationCharges??0 : 0);

          let allotmentObj = {
            // !remaining to minus cancellation charges
            firstPaymentDate: oldAllotmentData?.paidamount === 0 ? Date.now() : oldAllotmentData?.firstpaymentdate,
          paidAmount: paidData,
            paidAmt: null,
            // !remaining to minus cancellation charges from here
            status:
            paidData === 0
              ? "Payment Pending"
              : paidData > 0 && paidData < availableData?.allotedUnitData?.bookingAmt.total
                ? "Partial Payment Done"
                : paidData >= availableData?.allotedUnitData?.bookingAmt.total
                ? "Payment Complete"
                  : "Payment Pending",
            last_updated_at: new Date().getTime()
          };
          if (availableData?.allotedUnitData?.pricingType === "preselect" && allotmentObj.status==="Payment Complete") {
            allotmentObj.preselectConfirmation = "confirmation pending"
          }
          await updateAllotmentPayment(
            allotmentObj,
            availableData?.allotedUnitData?.allotmentPaymentId
          )
            .then((updateAllotmentPaymentRes) => {
              console.log({ updateAllotmentPaymentRes });
              // !remaining to minus cancellation charges from here
              updateLeadAllStatus(
                availableData?.allotedUnitData?.leadId,
              paidData === 0
                ? "Allotment Payment Pending"
                : paidData > 0 && paidData < availableData?.allotedUnitData?.bookingAmt.total
                  ? "Allotment Partial Payment Done"
                  : paidData >= availableData?.allotedUnitData?.bookingAmt.total
                  ? "Allotment Payment Complete"
                    : "Allotment Payment Pending"
              )
                .then((updatingLeadStatus) => {
                  console.log({ updatingLeadStatus });
                  // !remaining to minus cancellation charges from here
                  let leadLogsObj = {
                    leadId: availableData?.allotedUnitData?.leadId,
                    leadStatus:
                    paidData === 0
                      ? "Allotment Payment Pending"
                      : paidData > 0 && paidData < availableData?.allotedUnitData?.bookingAmt.total
                        ? "Allotment Partial Payment Done"
                        : paidData >= availableData?.allotedUnitData?.bookingAmt.total
                        ? "Allotment Payment Complete"
                          : "Allotment Payment Pending",
                    message: `Cancelled Unit:${oldAllotmentData.projectname},${oldAllotmentData.wingname},${oldAllotmentData.unitno}, balance amount: ${oldAllotmentData.paidamount} has been adjusted in ${availableData?.projectName}|${availableData?.wingName} |${availableData?.unitNo} done by ${loggedInUser?.name}(${loggedInUser?.roleId?.title})`,
                  };
                  addLeadLogs(leadLogsObj)
                    .then((leadLog) => {
                      console.log({ leadLog });
                      updateInventoryStatus(
                        availableData?.unitId,
                        (oldAllotmentData?.paidamount -
                          oldAllotmentData?.updatedunitprice
                            ?.cancellationCharges ?? 0) >=
                          availableData?.allotedUnitData?.bookingAmt.total
                          ? availableData?.allotedUnitData?.kycFormFilled
                            ? kycDoneInventoryStatus
                            : kycPendingInventoryStatus
                          : paymentPendingInventoryStatus
                      )
                        .then((updateInventoryStatus) => {
                          console.log({ updateInventoryStatus });
                          let InventoryLogObj = {
                            userId: loggedInUser?.userId,
                            leadId: availableData?.allotedUnitData?.leadId,
                            status:
                              (oldAllotmentData?.paidamount -
                                oldAllotmentData?.updatedunitprice
                                  ?.cancellationCharges ?? 0) >=
                                availableData?.allotedUnitData?.bookingAmt.total
                                ? kycPendingInventoryStatus
                                : availableData?.allotedUnitData?.kycFormFilled
                                  ? kycDoneInventoryStatus
                                  : paymentPendingInventoryStatus,
                            unitId: availableData?.unitId,
                          };
                          insertInventoryLogs(InventoryLogObj)
                          .then(async (insertInventoryLogsRes) => {
                              console.log({ insertInventoryLogsRes });
                            if (availableData?.allotedUnitData?.pricingType === "preselect") {
                              await getEventLeadTokenAmount(oldAllotmentData?.paymentId).then((tokenAmt) => {
                                console.log(tokenAmt);
                                let amt = oldAllotmentData?.paidamount > tokenAmt?.data?.amount ? tokenAmt?.data?.amount : oldAllotmentData?.paidamount < tokenAmt?.data?.amount ? oldAllotmentData?.paidamount : oldAllotmentData?.paidamount;
                                updateEventLeadTokenAmount(availableData?.allotedUnitData?.paymentId, amt).then((tokenResp) => {
                                  console.log({ tokenResp });
                                }).catch((err) => {
                                  console.log(err);
                                });
                              })
                            }
                              let allotmentObject = {
                                paymentTransferred: true,
                              }
                              updateAllotmentPayment(allotmentObject, oldAllotmentData?.allotmentpaymentid)
                                .then((updateAllotmentPaymentRes) => {
                                  console.log({ updateAllotmentPaymentRes });
                                  let bucketingObj = {
                                    allotmentPaymentId:
                                      availableData?.allotedUnitData
                                        ?.allotmentPaymentId,
                                  };
                                  bucketingForChangeUnit(bucketingObj)
                                    .then((bucketingResp) => {
                                      console.log({ bucketingResp });
                                      if (bucketingResp.data.success) {
                                        // ??success
                                        returnRes("adjustAlotDone");
                                        dismissLoader();
                                        setOpenAlertBoxForAdjustAmount(false);
                                        handleClose();
                                        successTost(
                                          "Allotment Done Successfully!"
                                        );
                                        sendMailAndSms(
                                          data?.leademail,
                                          "Adjust Allotment Done"
                                        ).then((resp) => { });
                                      } else {
                                        errorTost(bucketingResp.data.message);
                                        returnRes("adjustAlotDone");
                                        dismissLoader();
                                        setOpenAlertBoxForAdjustAmount(false);
                                        handleClose();
                                      }
                                    })
                                    .catch((err) => {
                                      console.log(err);
                                    });
                                })
                                .catch((err) => {
                                  console.log(err);
                              })
                            })
                            .catch((err) => {
                              console.log(
                                "err while inserting into inventory log",
                                err
                              );
                            });
                        })
                        .catch((err) => {
                          console.log(err);
                          dismissLoader();
                        });
                    })
                    .catch((err) => {
                      dismissLoader();
                      console.log("leadlog", err);
                    });
                })
                .catch((errorLeadStatus) => {
                  dismissLoader();
                  console.log({ errorLeadStatus });
                });
            })
            .catch((err) => {
              dismissLoader();
              console.log("err while updating allotment payment");
            });
        // } else {
        //   //??Payment first time
        //   errorTost("No transactions found");
        // }
      }
    );
  }
  // ??First Udpate old transactions =>allotmentPaymentId (new) update
  // ??.eq old transactions
  // ??getAllTransactions
  // ??Bucketing
  // ??update Allotment Payment ->paidAmount ,paidAmt
  // ??
  function inventoryStatus() {
    getAllInventoryStatusFromTable()
      .then((resp) => {
        console.log("Inventory=Status", resp);
        const paymentPendingStatus = resp.data.filter(
          (f) => f.status === "Payment Pending"
        );
        setPaymentPendingInventoryStatus(
          paymentPendingStatus[0]?.inventoryStatusId
        );

        const kycPending = resp.data.filter((f) => f.status === "Kyc Pending");
        setKycPendingInventoryStatus(kycPending[0]?.inventoryStatusId);

        const kycDone = resp.data.filter((f) => f.status === "Kyc Done");
        seKycDoneInventoryStatus(kycDone[0]?.inventoryStatusId);
      })
      .catch((err) => {
        console.error("Inventory=Status", err);
      });
  }
  return (
    <Modal
      open={open}
      onClose={(_, reason) => {
        if (reason !== "backdropClick") {
          closeModal();
        }
      }}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
      sx={[
        {
          ".MuiBackdrop-root": {
            background: "rgba(52, 64, 84, 0.7)",
          },
        },
      ]}
      disableAutoFocus={true}
    >
      <Box className={cssClasses.modalWrapper}>
        <div className={cssClasses.wrapperHeader}>
          <span className={classes.closeIcon} onClick={closeModal} tabIndex={0}>
            <Close width={"1.2rem"} height={"1.2rem"} />
          </span>
          <div>Adjust Allotment</div>
        </div>
        {showCancelledInFarvisionMsg ? (
          <div className={cssClasses.wrapperContent}>
            {" "}
            <div className={cssClasses.wrapperCancellationContent}>
              <div className={cssClasses.content}>
                <div className={cssClasses.titleEvent}>
                  This unit is cancelled in Farvision.Alot unit cannot be
                  performed.
                </div>
              </div>
            </div>
          </div>
        ) : (
          <div className={cssClasses.wrapperContent}>
            {hideChoices === false && allotmentTransactionFound && (
              <div className={cssClasses.content}>
                <div
                  className={cssClasses.wrapperEventBlock}
                  onClick={() => {
                    returnRes("alotUnit");
                    closeModal();
                  }}
                >
                  <div className={cssClasses.imageWrapper}>
                    <ImageOutlinedIcon sx={{ fontSize: "6rem" }} />
                  </div>
                  <p className={cssClasses.titleEvent}>Assign New Unit</p>
                  <ArrowCircleRightOutlinedIcon sx={{ fontSize: "4rem" }} />
                </div>
                <div
                  className={cssClasses.wrapperEventBlock}
                  onClick={() => {
                    setHideChoices(true);
                    setNumberNext(1);
                  }}
                >
                  <div className={cssClasses.imageWrapper}>
                    <ImageOutlinedIcon sx={{ fontSize: "6rem" }} />
                  </div>
                  <p className={cssClasses.titleEvent}>Assign Existing Unit</p>
                  <ArrowCircleRightOutlinedIcon sx={{ fontSize: "4rem" }} />
                </div>
              </div>
            )}
            {numberNext === 1 && hideChoices && (
              <div className={cssClasses.wrapperCancellationContent}>
                <div className={cssClasses.wrapperFirstBlock}>
                  <div className={cssClasses.firstBlockTitle}>Alotted Unit</div>
                  <div className={cssClasses.wrapperSecondBlock}>
                    <div className={cssClasses.wrapperBlock}>
                      <div className={cssClasses.blockLabel}>
                        All Allotted Projects{" "}
                        <span style={{ color: "red" }}> *</span>
                      </div>
                      <div style={{ width: "100%" }}>
                        <DropDown
                          list={uniqBy(projectNameList, "label")}
                          selectedValue={availableData?.projectId}
                          onChangeSelect={(_value) => {
                            console.log(_value);

                            let selectedProject;
                            selectedProject = projectNameList.filter(
                              ({ value }) => _value === value
                            );
                            console.log(selectedProject);
                            setAvailableData((pre) => {
                              if (_value !== pre.projectName) {
                                pre.wingName = "";
                                pre.unitId = "";
                                pre.unitNo = "";
                                pre.bookingAmt = null;
                                pre.selectedUnitId = "";
                                pre.floorNo = "";
                              }
                              pre.projectName = selectedProject[0]?.projectName;
                              pre.projectId = _value;
                              return { ...pre };
                            });
                            findWing(allotedData, _value);
                          }}
                          placeHolder={"Select Project"}
                          style={{
                            background: "#F2F4F7",
                            color: "rgb(102, 112, 133)",
                          }}
                        />
                      </div>
                    </div>
                    <div className={cssClasses.wrapperBlock}>
                      <div className={cssClasses.blockLabel}>
                        Wing <span style={{ color: "red" }}> *</span>
                      </div>
                      <div style={{ width: "100%" }}>
                        <DropDown
                          list={wingNameList.map((el) => {
                            return {
                              label: el?.unitData?.wingId?.wingName ?? el,
                              value: el?.unitData?.wingId?.wingId ?? el,
                            };
                          })}
                          selectedValue={availableData.wingId}
                          onChangeSelect={(value) => {
                            setAvailableData((pre) => {
                              pre.wingId = value;
                              pre.unitNo = "";
                              pre.floorNo = "";
                              pre.bookingAmt = null;
                              return { ...pre };
                            });
                            findFloor(
                              allotedData,
                              availableData?.projectId,
                              value
                            );
                          }}
                          placeHolder={"Select Wing"}
                          //style.color is placeHolder's color
                          style={{
                            background: "#F2F4F7",
                            color: "rgb(102, 112, 133)",
                          }}
                        />
                      </div>
                    </div>
                    <div className={cssClasses.wrapperBlock}>
                      <div className={cssClasses.blockLabel}>
                        Floor <span style={{ color: "red" }}> *</span>
                      </div>
                      <div style={{ width: "100%" }}>
                        <DropDown
                          list={floorList.map((el) => {
                            return {
                              label: el?.unitData?.floorNo ?? el,
                              value: el?.unitData?.floorNo ?? el,
                            };
                          })}
                          selectedValue={availableData.floorNo}
                          onChangeSelect={(value) => {
                            setAvailableData((pre) => {
                              pre.floorNo = value;
                              pre.bookingAmt = null;
                              pre.unitNo = "";
                              return { ...pre };
                            });
                            findUnit(
                              allotedData,
                              availableData?.projectId,
                              availableData?.wingId,
                              value
                            );
                          }}
                          placeHolder={"Select Floor"}
                          //style.color is placeHolder's color
                          style={{
                            background: "#F2F4F7",
                            color: "rgb(102, 112, 133)",
                          }}
                        //   disable={!ownedUnitData.isAllowed}
                        />
                      </div>
                    </div>
                    <div className={cssClasses.wrapperBlock}>
                      <div className={cssClasses.blockLabel}>
                        Unit <span style={{ color: "red" }}> *</span>
                      </div>
                      <div style={{ width: "100%" }}>
                        <DropDown
                          list={unitNoList.map((element, id) => {
                            return {
                              label: element?.unitData?.unitNo ?? element,
                              value: element?.unitData?.unitNo ?? element,
                            };
                          })}
                          selectedValue={availableData?.unitNo}
                          //   disable={!ownedUnitData.isAllowed}
                          onChangeSelect={(value) => {
                            console.log("unitNo", value);
                            let availableAllotedeData = allotedData.filter(
                              (el) => {
                                return (
                                  el?.unitData?.projectId?.projectId ===
                                  availableData.projectId &&
                                  el?.unitData?.wingId?.wingId ===
                                  availableData.wingId &&
                                  el?.unitData?.floorNo ===
                                  availableData.floorNo &&
                                  el?.unitData?.unitNo === value
                                );
                              }
                            );
                            console.log(availableAllotedeData[0]);
                            setAvailableData((pre) => {
                              pre.unitNo = value;
                              pre.unitId =
                                availableAllotedeData[0]?.unitData?.unitId;
                              pre.allotedUnitData = availableAllotedeData[0];
                              return { ...pre };
                            });
                          }}
                          placeHolder={"Select Unit No"}
                          //style.color is placeHolder's color
                          style={{
                            background: "#F2F4F7",
                            color: "rgb(102, 112, 133)",
                          }}
                        />
                      </div>
                    </div>
                  </div>
                  {availableData?.allotedUnitData !== null &&
                    availableData?.allotedUnitData !== undefined && (
                      <>
                        <div
                          className={cssClasses.firstBlockTitle}
                          style={{ marginTop: "2rem" }}
                        >
                          Summary
                        </div>
                        <div className={cssClasses.wrapperSecondBlock}>
                          <div className={cssClasses.wrapperBlockSecond}>
                            <div
                              className={cssClasses.blockLabel}
                              style={{ color: "#667085" }}
                            >
                              Paid Amount of {oldAllotmentData?.projectName},
                              {/* {oldAllotmentData?.wingname}, */}
                              {oldAllotmentData?.displaywingname ? oldAllotmentData?.displaywingname : oldAllotmentData?.wingname},
                              {oldAllotmentData?.unitno}
                            </div>
                            <div style={{ width: "100%", textAlign: "left" }}>
                              <div className={cssClasses.blockLabel}>
                                ₹ {numberWithCommas(oldAllotmentData?.paidamount)}
                              </div>
                            </div>
                          </div>
                          <div className={cssClasses.wrapperBlockSecond}>
                            <div
                              className={cssClasses.blockLabel}
                              style={{ color: "#667085" }}
                            >
                              Cancellation Charges of{" "}
                              {oldAllotmentData?.projectName},
                              {/* {oldAllotmentData?.wingname}, */}
                              {oldAllotmentData?.displaywingname ? oldAllotmentData?.displaywingname : oldAllotmentData?.wingname},
                              {oldAllotmentData?.unitno}
                            </div>
                            <div style={{ width: "100%", textAlign: "left" }}>
                              <div className={cssClasses.blockLabel}>
                                ₹{" "}
                                {numberWithCommas(
                                  oldAllotmentData?.updatedunitprice !== null ? oldAllotmentData?.updatedunitprice
                                    ?.cancellationCharges : 0
                                )}
                              </div>
                            </div>
                          </div>
                          {availableData?.allotedUnitData?.paidAmount !==
                            null && (
                              <div className={cssClasses.wrapperBlockSecond}>
                                <div
                                  className={cssClasses.blockLabel}
                                  style={{ color: "#667085" }}
                                >
                                  Paid Booking Amount of{" "}
                                  {availableData?.projectName},
                                  {/* {availableData?.wingName},{availableData?.unitNo} */}
                                  {availableData?.displayName ? availableData?.displayName : availableData?.wingName},{availableData?.unitNo}
                                </div>
                                <div style={{ width: "100%", textAlign: "left" }}>
                                  <div className={cssClasses.blockLabel}>
                                    ₹{" "}
                                    {numberWithCommas(
                                      availableData?.allotedUnitData?.paidAmount
                                    )}
                                  </div>
                                </div>
                              </div>
                            )}
                          <div className={cssClasses.wrapperBlockSecond}>
                            <div
                              className={cssClasses.blockLabel}
                              style={{ color: "#667085" }}
                            >
                              Booking Amount of {availableData?.projectName},
                              {/* {availableData?.wingName},{availableData?.unitNo} */}
                              {availableData?.displayName ? availableData?.displayName : availableData?.wingName},{availableData?.unitNo}
                            </div>
                            <div style={{ width: "100%", textAlign: "left" }}>
                              <div className={cssClasses.blockLabel}>
                                ₹{" "}
                                {numberWithCommas(
                                  availableData?.allotedUnitData?.bookingAmt
                                    ?.total
                                )}
                              </div>
                            </div>
                          </div>
                          {oldAllotmentData?.paidamount +
                            availableData?.allotedUnitData?.paidAmount >
                            availableData?.allotedUnitData?.bookingAmt?.total && (
                              <div className={cssClasses.blockLabel}>
                                Excess Amount to be adjusted in UnitCost
                              </div>
                            )}
                          {oldAllotmentData?.paidamount +
                            availableData?.allotedUnitData?.paidAmount <=
                            availableData?.allotedUnitData?.bookingAmt?.total && (
                              <div className={cssClasses.blockLabel}>
                                Amount to be paid:₹{" "}
                                {numberWithCommas(
                                  availableData?.allotedUnitData?.bookingAmt?.total -
                                  // CHanges added by Mayur!!! parseInt
                                  (oldAllotmentData?.paidamount - parseInt(oldAllotmentData?.updatedunitprice?.cancellationCharges ?? 0)) - availableData?.allotedUnitData?.paidAmount ?? 0

                                )}
                              </div>
                            )}

                          {/* <div className={cssClasses.wrapperBlock}>
      <div className={cssClasses.blockLabel}>
        Allotment Status
      </div>
      <div style={{ width: "100%", textAlign: "left" }}>
      <LeadStatusChip
    style={availableData?.allotedUnitData?.status === "pending"
    ? {
        color: "#B54708",
        backgroundColor: "#FFFAEB",
      }
    : availableData?.allotedUnitData?.status === "Payment Complete"
    ? {
        color: "#027A48",
        backgroundColor: "#ECFDF3",
      }
    : {
        color: "#B54708",
        backgroundColor: "#FFF4ED",
      }}
    label={availableData?.allotedUnitData?.status}
    icon={<Dot width={"0.5rem"} height={"0.5rem"} />}
  />
      </div>
    </div> */}
                        </div>
                      </>
                    )}
                </div>
              </div>
            )}
            {!allotmentTransactionFound && (
              <div className={cssClasses.wrapperCancellationContent}>
                <div className={cssClasses.content}>
                  <div className={cssClasses.titleEvent}>
                    Allotment is already done!{" "}
                  </div>
                </div>
              </div>
            )}
          </div>
        )}
        {/* Event Button */}
        {hideChoices && (
          <div className={cssClasses.wrapperFooter}>
            <div>
              <Button
                style={{
                  color: "#344054",
                  backgroundColor: "#ffffff",
                  fontSize: "1.6rem",
                  lineHeight: "2.4rem",
                }}
                btnName={"Back"}
                clicked={() => {
                  let _numberNext = numberNext - 1;
                  setHideChoices(false);
                  console.log(_numberNext);
                }}
              />
            </div>
            <div>
              <Button
                style={{
                  color: "#ffffff",
                  backgroundColor: "#155EEF",
                  fontSize: "1.6rem",
                  lineHeight: "2.4rem",
                }}
                disable={
                  availableData?.allotedUnitData === undefined ||
                  availableData?.allotedUnitData === null
                }
                btnName={"Submit"}
                clicked={() => {
                  setOpenAlertBoxForAdjustAmount(true);
                  // temporaryBucketing()
                }}
              //   disable={disabeNext}
              />
            </div>
          </div>
        )}
        {openAlertBoxForAdjustAmount && (
          <ConfirmationAlert
            confirm={(e) => {
              if (e === "confirmed") {
                submit();
                handleClose()
              }
            }}
            buttonTitle={"No"}
            returnRespButton={"Yes"}
            close={() => setOpenAlertBoxForAdjustAmount(false)}
            title={"Info"}
            subTitle={`Are you sure you want to adjust amount?`}
            open={openAlertBoxForAdjustAmount}
          />
        )}
      </Box>
    </Modal>
  );
}
